import { useContext as t } from "react";
import { CalendarContext as e } from "./atoms-v2772.js";
function n() {
  return t(e);
}
export {
  n as useCalendarContext
};
